import { Component, EventEmitter, Inject, Input, Output, OnInit,OnDestroy,ViewChild } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import _ from 'lodash';
import {moment} from '../../../js/globals';
@Component({
  standalone: false,
  selector: 'mysynch-multi-select',
  templateUrl: '../app/form-controls/mysynch-multiselect/mysynch-multiselect.view.html',
  styleUrls:['../app/form-controls/mysynch-multiselect/mysynch-multiselect.style.css','../css/ng-select/default.theme.css','../css/ng-select/ng-select.component.css']
})
export class MySynchMultiSelect implements OnInit, OnDestroy {
    
    @ViewChild('ngSelectRef') ngSelect: NgSelectComponent;

    @Input() controlId:any
    @Input() labelProperty: string;
    @Input() valueProperty: string;
    ///@Input() model: any[];
    @Input() placeholder: string;
    @Input() closeOnSelect: boolean = false;
    @Input() multiple: boolean = true;
    @Input() searchable: boolean = false;
    @Input() virtualScroll: boolean = false;
    @Input() appendTo: string = null;
    @Input() set labelDisplayField(field:string){
      this._labelDisplayField = field;
    };
    @Input() set valueKeyField(field:string){
      this._valueKeyField = field;
    };
    @Input() set orderByFields(fields:any[]){
      this._orderByFields = fields;
    };
    @Input() set orderByDirections(directions:any[]){
      this._orderByDirections = directions;
    };

    @Input() selectedItems: any[] = [];

    @Input() set items(items: any[]){
      this._items = _.sortByOrder(items,this.orderByFields,this.orderByDirections);
       
      this._selectedItemsDisplayLabel = this.getSelectedItemsLabel(this.selectedItems);
      this._selectedItemsDemoUserDisplayLabel = this.getSelectedDemoUserItemsLabel(this.selectedItems);
    };

    @Input() disableDemoUserFilter: boolean = true;
    @Input() demoUserValueKey: string = "id";

    @Output() onSelectAdd = new EventEmitter<any[]>();
    @Output() onSelectChange = new EventEmitter<any[]>();
    @Output() onSelectOpen = new EventEmitter<any>();
    @Output() onSelectClose = new EventEmitter<any>()
    
    _items: any[] = [];
    _labelDisplayField: string;
    _valueKeyField: string;
    _orderByFields: any[];
    _orderByDirections: any[] = ['asc'];
    _selectedItemsDisplayLabel: string;
    _selectedItemsDemoUserDisplayLabel: string;

  
    _:any;
    
    constructor(@Inject('MySynchFactory') private MSF:any){
      this._ = _;
    }

    ngOnInit() {
       this._selectedItemsDisplayLabel = this.getSelectedItemsLabel(this.selectedItems);
       this._selectedItemsDemoUserDisplayLabel = this.getSelectedDemoUserItemsLabel(this.selectedItems);
       
    }
    ngOnDestroy(): void {
      console.log('[mysynch-multiselect] destroyed');
      this.onSelectAdd.complete();
      this.onSelectChange.complete();
      this.onSelectOpen.complete();
      this.onSelectClose.complete();
    }
   
    get items():any[] {
     return this._items;
    }
   
  
    getSelectedDemoUserItemsLabel(items){
      return _.map(items,(item)=>_.get(item,this.demoUserValueKey)).join(', ');
    }
    getSelectedItemsLabel(items){
      return _.map(items,(item)=>_.get(item,this._labelDisplayField)).join(', ');
    }
    getOptionsLabel(item){
      return _.get(item,this._labelDisplayField);
    }
    getOptionsDemoLabel(item){
      return _.get(item,this.demoUserValueKey);
    }

    trackByFn(index, item){
       return _.get(index,'id'); // or item.id
    }
    compareWith(item1:any,item2:any){
      return _.isEqual(_.get(item1,'id'),_.get(item2,'id'));
    }

    onOpen(){
        this.MSF.waitForElm("#chkboxSelectAll").then((elm)=>{
            if(!this.isAllSelected()){
              $("#chkboxSelectAll").prop('checked',false); 
            }else{
              console.log("Setting Select All true in onOpen !!!!");
              $("#chkboxSelectAll").prop('checked',true);
            }
            this.onSelectOpen.emit();
          })    
    }

    onClose(){
     this.onSelectClose.emit();
    }


    onAdd(option:any):void{
      this.onSelectAdd.emit(option);
    }
    
    onChange(options:any):void{
    
      if(!this.isAllSelected()){
        $("#chkboxSelectAll").prop('checked',false); 
      }else{
        $("#chkboxSelectAll").prop('checked',true);
      }
      this._selectedItemsDisplayLabel = this.getSelectedItemsLabel(options);
      this._selectedItemsDemoUserDisplayLabel = this.getSelectedDemoUserItemsLabel(options);
      this.onSelectChange.emit(options);
   }

   onRemove(){
     $("#chkboxSelectAll").prop('checked',false); 
   }
   isChecked(item){
      
    return _.includes( _.map(this.selectedItems,(item)=>_.get(item,this._valueKeyField)),
                         _.get(item,this._valueKeyField)
                        );
   }
   isAllSelected(){
      return _.every(this._items,(item)=>!_.isUndefined(_.find(this.selectedItems,(selItem)=>_.isEqual(_.get(item,this._valueKeyField),_.get(selItem,this._valueKeyField)))));
   }

   selectAll(){
    if(!this.isAllSelected()){ 
        this.selectedItems = [...this._items]; // create a new array
        $("#chkboxSelectAll").prop('checked',true); 
       this.onSelectChange.emit(this.selectedItems);
   
    }else{
        this.selectedItems = [];
        $("#chkboxSelectAll").prop('checked',false);
       this.onSelectChange.emit(this.selectedItems);
    }
    this._selectedItemsDisplayLabel = this.getSelectedItemsLabel(this.selectedItems);
    this._selectedItemsDemoUserDisplayLabel = this.getSelectedDemoUserItemsLabel(this.selectedItems);
  } 
  closeDropdown() {
      if (this.ngSelect) {
        this.ngSelect.close();
      }
    }
}